(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("leaflet"), require("leaflet-maplibre-gl"), require("leaflet.markercluster"));
	else if(typeof define === 'function' && define.amd)
		define([, , ], factory);
	else if(typeof exports === 'object')
		exports["MemorialMap"] = factory(require("leaflet"), require("leaflet-maplibre-gl"), require("leaflet.markercluster"));
	else
		root["MemorialMap"] = factory(root["leaflet"], root["leaflet-maplibre-gl"], root["leaflet.markercluster"]);
})(window, (__WEBPACK_EXTERNAL_MODULE__109__, __WEBPACK_EXTERNAL_MODULE__698__, __WEBPACK_EXTERNAL_MODULE__207__) => {
return 